import Spinners from "components/Common/Spinner"
import TableContainer from "components/Common/TableContainer"
import React, { useEffect, useMemo, useState } from "react"
import "react-quill/dist/quill.snow.css"

import { Card, CardBody, Col, Row } from "reactstrap"
import API_SERVICE from "shared/services/api-services"
import { notification } from "shared/utility/Utility"
import { useNavigate } from "react-router-dom"

const cellStyles = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "150px",
  margin: "0 auto",
}

const QAndAList = () => {
  const [questionAndAnswerList, setQuestionAndAnswerList] = useState([])
  const [loading, setLoading] = useState(true)

  const navigate = useNavigate()

  const columns = useMemo(
    () => [
      {
        header: "S.No.",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cell => {
          return <p style={cellStyles}>{cell.row.index + 1}</p>
        },
      },
      {
        header: "Ques Img",
        accessorKey: "image_url",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cell => {
          return (
            <a
              href={cell.row.original.image_url}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={cell.row.original.image_url}
                alt="Ques Img"
                style={{ width: "50px", height: "50px" }}
              />
            </a>
          )
        },
      },
      {
        header: "Ques text",
        accessorKey: "question",
        enableColumnFilter: false,
        enableSorting: true,
        width: "100px",
        cell: cell => {
          return <p style={cellStyles}>{cell.row.original.question || "N/A"}</p>
        },
      },
      {
        header: "Type",
        accessorKey: "question_type",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cell => {
          return (
            <p style={cellStyles}>{cell.row.original.question_type || "N/A"}</p>
          )
        },
      },
      {
        header: "Status",
        accessorKey: "isActive",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cell => {
          return cell.row.original.isActive ? "Active" : "Inactive"
        },
      },
      {
        header: "Webhook",
        accessorKey: "webhookIdentifier",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Segment",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cell => {
          return (
            <p style={cellStyles}>{cell.row.original.segment?.name || "N/A"}</p>
          )
        },
      },
      {
        header: "Question Description",
        accessorKey: "description",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cell => {
          return (
            <p
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={cell.row.original.description || "N/A"}
              style={cellStyles}
            >
              {cell.row.original.description || "N/A"}
            </p>
          )
        },
      },
      {
        header: "Ques Short Text",
        accessorKey: "shortForm",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cell => {
          return (
            <p
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={cell.row.original.shortForm || "N/A"}
              style={cellStyles}
            >
              {cell.row.original.shortForm || "N/A"}
            </p>
          )
        },
      },
      {
        header: "Actions",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "view",
        cell: cell => {
          return (
            <div style={{ display: "flex", gap: "8px" }}>
              <span
                className="bx bx-pencil"
                style={{
                  cursor: "pointer",
                  color: "blue",
                }}
                onClick={() => navigate(`/q-n-a/${cell.row.original.id}`)}
              ></span>
              <span
                className="bx bx-trash"
                style={{
                  cursor: "pointer",
                  color: "red",
                }}
                onClick={() => deleteRow(cell.row.original.id)}
              ></span>
            </div>
          )
        },
      },
    ],
    []
  )

  const deleteRow = async id => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.deleteQuestion(id)
      notification("success", "Question deleted successfully")
      getQuestionAndAnswerList()
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }

  const getQuestionAndAnswerList = async () => {
    try {
      setLoading(true)
      const {
        data: { data },
      } = await API_SERVICE.getQuestionAndAnswerList()
      setQuestionAndAnswerList(data)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getQuestionAndAnswerList()
  }, [])

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col xs={12}>
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">Question LIST</h4>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody
                  style={{
                    minHeight: "calc(100vh - 230px)",
                  }}
                >
                  {loading ? (
                    <Spinners />
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={questionAndAnswerList || []}
                      isGlobalFilter={true}
                      isAddButton={true}
                      isCustomPageSize={true}
                      handleUserClick={() =>
                        navigate("/q-n-a/add-new-question")
                      }
                      isPagination={true}
                      SearchPlaceholder="26 records..."
                      buttonClass="btn btn-primary bg-white text-primary border-0 outline-0 waves-effect waves-light"
                      buttonName=" Add New Question"
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}

export default QAndAList
